export default __webpack_public_path__ + "static/media/closeicon.aad32ea8.svg";